import { Grid, TextField, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { AuditListingProps } from 'src/types';

interface Props {
  canSeeCount: boolean;
  handleAuditCountChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    product_id?: number
  ) => void;
}

export const AuditAndAvailableCounts: FC<AuditListingProps & Props> = ({
  id,
  isSerialized,
  auditedCount,
  availableListingCount,
  canSeeCount,
  handleAuditCountChange
}) => {
  return (
    <Grid item xs={12} container style={{ gap: '1em' }}>
      <Grid item xs container>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Typography variant="h6">Audited Count</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          {!isSerialized ? (
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              id="audited-count"
              type="number"
              defaultValue={auditedCount || 0}
              value={auditedCount}
              onChange={(e: any) => handleAuditCountChange?.(e, id)}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                step: 1,
                min: 0,
                max: availableListingCount,
                style: { textAlign: 'center' }
              }}
            />
          ) : (
            <Typography>{auditedCount}</Typography>
          )}
        </Grid>
      </Grid>

      {canSeeCount ? (
        <Grid item xs container>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
            <Typography variant="h6">Available Items Count</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Typography>{availableListingCount}</Typography>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};
